import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { tryLogin } from "./reducers/authSlice"
import "./App.css"
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom"
import DnBoard from "./pages/DnBoard"
//import Dashboard from './components/Dashboard'
import Dn from "./pages/Dn"
import TruckList from "./pages/TruckList"
import MapView from "./pages/MapView"
import TruckView from "./pages/TruckView"
import TruckInYard from "./pages/TruckInYard"
import AppNav from "./components/AppNav"
import React from "react"
import DnTrack from "./pages/DnTrack"
import SignInSide from "./components/auth/SignInSide"
import Home from "./pages/Home"
import ReportDriver from "./pages/ReportDriver"
import ReportWarp from "./pages/ReportWarp"
import ReportTraccar from "./pages/ReportTraccar"
import TruckReady from "./pages/TruckReady"
import TruckChaAm from "./pages/TruckChaAm"
import GpsMonitor from "./pages/GpsMonitor"
import ReportTruckGantt from "./pages/ReportTruckGantt"
import UserManagement from "./pages/UserManagement"
import { isAdmin, isSuperAdmin } from "./utils/roles"

function App() {
  // Initial Authentication State
  // const user_data = useSelector((state) => state.auth.user)
  // const isLogedIn = useSelector((state) => state.auth.isLogedIn)
  const dispatch = useDispatch()
  //let location = useLocation()
  useEffect(() => {
    dispatch(tryLogin())
  }, [dispatch])

  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route path="/auth">
            <Route path="/auth/login">
              <SignInSide />
            </Route>
          </Route>
          <PrivateRoute path="/">
            <AppNav />
            <Route exact path="/">
              <Home />
            </Route>
            <Route path="/board">
              <RequireRole check={isAdmin}>
                <DnBoard />
              </RequireRole>
            </Route>
            <Route path="/dashboard">
              <DnTrack />
            </Route>
            <Route path="/legacy_dashboard">
              <RequireRole check={isAdmin}>
                <Dn />
              </RequireRole>
            </Route>
            <Route path="/trucklist">
              <RequireRole check={isAdmin}>
                <TruckList />
              </RequireRole>
            </Route>
            <Route path="/mapview">
              <RequireRole check={isAdmin}>
                <MapView />
              </RequireRole>
            </Route>
            <Route path="/truckview">
              <RequireRole check={isAdmin}>
                <TruckView />
              </RequireRole>
            </Route>
            <Route path="/truckinyard">
              <RequireRole check={isAdmin}>
                <TruckInYard />
              </RequireRole>
            </Route>
            <Route path="/report_driver">
              <RequireRole check={isAdmin}>
                <ReportDriver />
              </RequireRole>
            </Route>
            <Route path="/report_warp">
              <RequireRole check={isAdmin}>
                <ReportWarp />
              </RequireRole>
            </Route>
            <Route path="/report_traccar">
              <RequireRole check={isAdmin}>
                <ReportTraccar />
              </RequireRole>
            </Route>
            <Route path="/truck-ready">
              <RequireRole check={isAdmin}>
                <TruckReady />
              </RequireRole>
            </Route>
            <Route path="/truck-cha-am">
              <RequireRole check={isAdmin}>
                <TruckChaAm />
              </RequireRole>
            </Route>
            <Route path="/gps-monitor">
              <RequireRole check={isAdmin}>
                <GpsMonitor />
              </RequireRole>
            </Route>
            <Route path="/users">
              <RequireRole check={isSuperAdmin}>
                <UserManagement />
              </RequireRole>
            </Route>
            <Route path="/truck_gantt">
              <RequireRole check={isAdmin}>
                <ReportTruckGantt />
              </RequireRole>
            </Route>
          </PrivateRoute>
        </Switch>
      </Router>
    </React.Fragment>
  )
}

// กันเปิดหน้า admin ด้วยการพิมพ์ URL ตรง — ไม่ผ่านให้กลับหน้า Home
function RequireRole({ check, children }) {
  const user_data = useSelector((state) => state.auth.user)
  return check(user_data) ? children : <Redirect to="/" />
}

function PrivateRoute({ children, ...rest }) {
  const isLogedIn = useSelector((state) => state.auth.isLogedIn)
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isLogedIn === null ? (
          <div>Loading</div>
        ) : isLogedIn === true ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/auth/login",
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}

export default App
